// src/types/pushPrefs.ts — Préférences push téléphone (Phase 2)

import type { NotificationType } from './notifications';
import { PUSH_ELIGIBLE_TYPES } from '../utils/pushEligibleTypes';

/** Types whitelist pour lesquels l’utilisateur peut désactiver le push. */
export type PushEligibleNotificationType = (typeof PUSH_ELIGIBLE_TYPES)[number];

/**
 * Préférences push au niveau user (`users/{uid}.pushPrefs`).
 * Absence du champ = comportement Phase 1 (push ON, tous types whitelist, pas de quiet hours).
 */
export interface UserPushPrefs {
  /** Master : false = aucun push OS (cloche in-app inchangée). Défaut true si absent. */
  enabled?: boolean;
  /**
   * Opt-out par type whitelist. Clé absente = autorisé.
   * `false` = ne pas pusher ce type.
   */
  types?: Partial<Record<PushEligibleNotificationType, boolean>>;
  /**
   * Quiet hours (horloge locale du fuseau). Ex. 21→7.
   * Types « urgents » bypassent (voir `PUSH_QUIET_HOURS_BYPASS_TYPES`).
   */
  quietHours?: {
    enabled: boolean;
    /** 0–23 inclus */
    startHour: number;
    /** 0–23 inclus (peut être < startHour si plage nocturne) */
    endHour: number;
    /** IANA, défaut Africa/Douala */
    timeZone?: string;
  };
}

export const DEFAULT_PUSH_QUIET_TIMEZONE = 'Africa/Douala';

/** Types qui passent quand même pendant quiet hours. */
export const PUSH_QUIET_HOURS_BYPASS_TYPES: readonly NotificationType[] = [
  'appointment_request',
  'pickup_request',
  'appointment_reminder_2h',
  'payment_plan_reminder_due',
  'payment_plan_overdue',
  'activity_report_submit_reminder',
  'activity_report_overdue',
  'licence_payment_blocked',
] as const;
